module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    attrs: {
      "id": "cat_cont"
    }
  }, [_c('image', _vm._b({
    attrs: {
      "id": "cat",
      "width": "300",
      "height": "180",
      "transform": "matrix(0.4448 0 0 0.4448 609.8432 697.8701)"
    },
    on: {
      "mouseover": _vm.mouseOver
    }
  }, 'image', {
    'xlink:href': _vm.cat1
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc554968"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home_elements/Cat.vue
// module id = 575
// module chunks = 1